import { useContext } from "react";
import { RequestContext, RequestContextType } from "./RequestProvider";

function useRequest() {
    return useContext(RequestContext) as RequestContextType;
}

export default useRequest;
